import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box, SxProps, Theme } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { ManageCampaign } from '../../pages/ManageCampaign/ManageCampaign';
import CloseIcon from '../CustomSVGIcons/CloseIcon';

export interface IEsContestEngageModal {
    open: boolean;
    onClose: () => void;
    paperStyle?: React.CSSProperties;
    childrenStyle?: SxProps<Theme>;
    paperSx?: SxProps<Theme>;
}

const CampaignManageModal: React.FC<IEsContestEngageModal> = ({
    open,
    onClose,
    paperStyle,
    childrenStyle,
    paperSx,
}) => {
    const { themeStyle } = useThemeContext();

    return (
        <Box>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth
                fullScreen
                PaperProps={{
                    style: {
                        backgroundColor: theme[themeStyle].pure_black,
                        height: '100vh',
                        width: '100vw',
                        overflowY: 'auto',
                        border: 'none',
                        borderRadius: 0,
                        margin: 0,
                        ...paperStyle,
                    },
                    sx: paperSx,
                }}
                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: theme[themeStyle].modal_dark,
                    },
                }}>
                <CloseIcon
                    style={{ position: 'absolute', top: 10, right: 10, cursor: 'pointer' }}
                    onClick={onClose}
                    stroke={theme[themeStyle].tag_white}
                />
                <DialogContent sx={childrenStyle}>
                    <ManageCampaign onClose={onClose} />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export { CampaignManageModal };
